import { autoRegisterUrl } from "./endpoints.js";
const autoRegisterCacheKey = (props) => [autoRegisterUrl, props];
export {
  autoRegisterCacheKey
};
//# sourceMappingURL=cacheKeys.js.map
